import React from "react";
import { Link } from "react-router-dom";
export default function ScrollableImmagini({titolo,prezzo,immagine,elemento}){

    let ritornoPrezzo = ()=>{
        if(prezzo>=0){
            return <span className="price">€{prezzo}</span>
        }
        return <span className="price">{prezzo}</span>
    };

    return (

        <div className="product-box">
            <Link to={`../prodotti/${elemento}-${(titolo).split(" ").join("_")}`}>
                <img src={immagine[0]} alt="cover" className="product-img"/>
            </Link>
            <h3 style={{textAlign:"center"}}>{titolo}</h3>
            {ritornoPrezzo()}
        </div>

    )
}